export class Validaciones {
  preCargarForm: boolean;
  puedeAgregarMultiples: boolean;
}
